import { Tooltip, Typography } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

const DashboardAnalyticsWrapper = styled.div`
  display: flex;
  gap: var(--size-16);
  margin-bottom: var(--size-16);
`;

const DashboardAnalyticsGroup = styled.div`
  border: 1px solid var(--color-border-default);
  border-radius: var(--size-border-radius-md);
  display: flex;
  justify-content: space-around;
  padding: ${({ isLoading }) => (isLoading ? 'var(--size-16) 0' : 'var(--size-16) var(--size-40)')};
  width: 100%;
`;

const DashboardAnalyticsItem = styled.div`
  text-align: center;
`;

const DashboardAnalyticsItemInfo = styled.div`
  align-items: center;
  display: flex;
  gap: var(--size-2);

  ${Tooltip.S.TooltipContent} {
    display: inline;
  }

  ${Typography.S.Typography} {
    white-space: nowrap;
  }
`;

const DashboardAnalyticsItemCount = styled.div`
  align-items: center;
  display: flex;
  gap: var(--size-4);
  justify-content: center;
`;

export {
  DashboardAnalyticsGroup,
  DashboardAnalyticsItem,
  DashboardAnalyticsItemCount,
  DashboardAnalyticsItemInfo,
  DashboardAnalyticsWrapper
};
